import {
  getClientInstallationInstructions,
  getLanguageConfig,
  getSupportedLanguages
} from "./chunk-WG7B3EVC.js";

// src/index.ts
import { HTTPSnippet, addClientPlugin } from "@readme/httpsnippet";
import generateHar from "@readme/oas-to-har";
function oasToSnippet(oas, operation, values, auth, lang, opts = {}) {
  let config;
  let language;
  let target;
  const plugins = opts.plugins || [];
  const languages = getSupportedLanguages({
    plugins
  });
  try {
    ({ config, language, target } = getLanguageConfig(languages, lang));
  } catch (err) {
    if (!language || !target) {
      return { code: "", highlightMode: false, install: false };
    }
  }
  if (!config) {
    throw new Error(
      `The supplied language \`${lang.toString()}\` is not supported. If a plugin powers this language please initialize that plugin with the \`plugins\` option.`
    );
  }
  if (!language || !target) {
    return { code: "", highlightMode: false, install: false };
  }
  const har = opts.harOverride || generateHar(oas, operation, values, auth);
  const snippet = new HTTPSnippet(har, {
    // We should only expect HAR's generated with `@readme/oas-to-har` to already be encoded.
    harIsAlreadyEncoded: !opts.harOverride
  });
  let targetOpts = config.httpsnippet.targets[target].opts || {};
  const highlightMode = config.highlight;
  plugins.forEach((plugin) => {
    addClientPlugin(plugin);
    if (plugin.target === "node" && plugin.client.info.key === "api") {
      targetOpts.api = {
        definition: oas ? oas.getDefinition() : null,
        identifier: opts?.openapi?.variableName,
        registryURI: opts?.openapi?.registryIdentifier
      };
    }
  });
  const install = getClientInstallationInstructions(languages, lang, opts?.openapi?.registryIdentifier) || false;
  try {
    const code = snippet.convert(language, target, targetOpts);
    return {
      code: code ? code[0] : false,
      highlightMode,
      install
    };
  } catch (err) {
    if (language !== "node" && target !== "api") {
      throw err;
    }
    targetOpts = config.httpsnippet.targets.fetch.opts || {};
    const code = snippet.convert(language, "fetch", targetOpts);
    return {
      code: code ? code[0] : false,
      highlightMode,
      install: false
    };
  }
}
export {
  oasToSnippet as default
};
//# sourceMappingURL=index.js.map